<ng-container [formGroup]="form" *ngIf="schema">
  <div class="row">
    <div class="col-12">
      <lds-text-input
        formControlName="payeeName"
        label="Payee name"
        placeholder="payee name"
        [isRequired]="schema.payeeName | standardRequirement"
        [maxlength]="100"
        [validations]="{
          required: 'Payee name is required'
        }">
      </lds-text-input>
    </div>
  </div>

  <div class="row">
    <ng-container formGroupName="upfront">
      <div class="col-3">
        <lds-select
          formControlName="type"
          name="type"
          label="Upfront amount type"
          [isRequired]="
            (schema.upfront.percent | standardRequirement) ||
            (schema.upfront.amount | standardRequirement)
          "
          [options]="upfrontType | stringArray | ldsSelectOption"
          [validations]="{
            required: 'Upfront type is required'
          }">
        </lds-select>
      </div>

      <div class="col-3" *ngIf="isUpfrontPercent">
        <spark-shared-percentage
          formControlName="percent"
          label="Upfront percent"
          [isRequired]="
            isUpfrontPercent && schema.upfront.percent | standardRequirement
          "
          [validations]="{
            required: 'Upfront percent is required'
          }">
        </spark-shared-percentage>
      </div>
      <div class="col-3" *ngIf="!isUpfrontPercent">
        <lds-currency-input
          formControlName="amount"
          name="upfrontAmount"
          label="Upfront amount"
          [isRequired]="
            !isUpfrontPercent && schema.upfront.amount | standardRequirement
          "
          [decimals]="2"
          [maxlength]="15">
        </lds-currency-input>
      </div>
    </ng-container>

    <div class="col-3">
      <spark-shared-percentage
        formControlName="trail"
        label="Trail percent"
        [isRequired]="schema.trail | standardRequirement">
      </spark-shared-percentage>
    </div>
  </div>
</ng-container>
